import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import styles from './PaymentTypeText.styles';

const useStyles = createUseStyles(styles);
export function PaymentTypeTextComponent({ label, value }) {
  const classes = useStyles();

  return (
    <div className={classes.paymentType}>
      <p>{label}</p>
      <p>{value}</p>
    </div>
  );
}

PaymentTypeTextComponent.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
};
PaymentTypeTextComponent.defaultProps = {
  label: '',
  value: ''
};

export default PaymentTypeTextComponent;
